import { useRef, useState, useMemo } from "react";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Input from 'react-phone-number-input/input'
import countryList from 'react-select-country-list';
import quickResponseJson from '../../Content/Data/QuickResponse/quickResponse.json';
import 'react-phone-number-input/style.css'

function QuickResponse() {

    const formRef = useRef(null);
    const [phoneValue, setPhoneValue] = useState();
    const [countryValue, setCountryValue] = useState({ value: 'IN', label: 'India' });
    const countryOptions = useMemo(() => countryList().getData(), []);
    const animatedComponents = makeAnimated();

    function handleSubmit(event) {
        event.preventDefault();
        // Handle form submission logic here
    }

    return (
        <div className="quick-response">
            <div className="quick-response-container">
                <form ref={formRef} className="quick-response-form" onSubmit={handleSubmit}>
                    {
                        quickResponseJson.map((item, index) => {
                            let options = [];
                            return (
                                <div key={index} className={item.ShowFlex ? "quick-response-form-group flex-column gap-10" : "quick-response-form-group"}>
                                    {item.Header && <label>{item.Header}</label>}
                                    {
                                        !item.IsDropdown ?
                                            item.Fields.map((field, fieldIndex) => {
                                                if (field.Type === "textarea") {
                                                    return (
                                                        <textarea
                                                            key={fieldIndex}
                                                            id={`${field.Type}_${fieldIndex}`}
                                                            required={field.Required}
                                                            className="quick-response-form-control-textarea"
                                                            placeholder={field.Name}
                                                        />
                                                    );
                                                }
                                                else if (field.Type === "checkbox") {
                                                    return (
                                                        <div
                                                            key={fieldIndex}
                                                            className="quick-response-form-group-checkbox flex"
                                                        >
                                                            <input
                                                                id={`${field.Type}_${fieldIndex}`}
                                                                type="checkbox"
                                                                required={field.Required}
                                                                className="quick-response-form-control-checkbox"
                                                                placeholder={field.Name}
                                                            />
                                                            <label htmlFor={`${field.Type}_${fieldIndex}`}>{field.Name}</label>
                                                        </div>
                                                    );
                                                }
                                                else if (field.Type === "dropdown") {
                                                    if (field.DropdownType.toLowerCase() === "country") {
                                                        return (
                                                            <div
                                                                key={fieldIndex} className="quick-response-form-control">
                                                                <Select
                                                                    options={countryOptions}
                                                                    value={countryValue}
                                                                    onChange={(value) => { setCountryValue(value); }}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    else if (field.DropdownType.toLowerCase() === "phone") {
                                                        return (
                                                            <div key={fieldIndex} className="quick-response-form-control">
                                                                <Input
                                                                    country={countryValue?.value}
                                                                    placeholder="Enter phone number"
                                                                    value={phoneValue}
                                                                    onChange={(value) => { value && setPhoneValue(value); }}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    else {

                                                    }
                                                }
                                                else {
                                                    return (
                                                        <input
                                                            key={fieldIndex}
                                                            id={`${field.Type}_${fieldIndex}`}
                                                            type={field.Type}
                                                            required={field.Required}
                                                            className="quick-response-form-control-input"
                                                            placeholder={field.Name}
                                                        />
                                                    );
                                                }
                                            })
                                            :
                                            <div>
                                                {
                                                    item.Fields.map((field, fieldIndex) => {
                                                        options.push({ value: field.Name, label: field.Name });
                                                    })
                                                }
                                                <Select
                                                    closeMenuOnSelect={false}
                                                    components={animatedComponents}
                                                    defaultValue={[]}
                                                    isMulti={item.IsMultiSelect}
                                                    options={options}
                                                />
                                            </div>
                                    }
                                </div>
                            );
                        })
                    }
                    <div className="quick-response-form-group">
                        <input id="submit" type="submit" className="quick-response-form-control-btn" value="Submit" />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default QuickResponse;
